import { NavLink, Outlet } from "react-router-dom";
import { AppShell } from "@/components/AppShell";
import { RoleProvider } from "./lib/RoleContext";

export const CONF_SECTIONS = [
  { label: "Overview", tabs: [["", "Dashboard"], ["parties", "Parties"]] },
  { label: "Conference", tabs: [["orders", "Conference Order"], ["summary", "Order Summary"], ["company-order", "Company Order"]] },
  { label: "Stock", tabs: [["stock", "In House Stock"], ["balance-order", "Balance Order"],
                           ["balance", "Balance Stock"], ["extra-stock", "Extra Stock"]] },
  { label: "Company Orders", tabs: [["conf-company-order", "Conference Company Order"],
                                    ["wholesale-company-order", "Wholesale Company Order"]] },
];

export default function ConferenceLayout({ profile }) {
  return (
    <RoleProvider>
      <AppShell profile={profile}>
        <div className="border-b border-zinc-200 bg-white">
          <div className="mx-auto flex max-w-[1600px] flex-wrap items-center gap-x-5 gap-y-2 px-4 py-2 sm:px-8">
            {CONF_SECTIONS.map((s) => (
              <div key={s.label} className="flex items-center gap-1">
                <span className="mr-1 text-[10px] font-bold uppercase tracking-[0.18em] text-zinc-400">{s.label}</span>
                {s.tabs.map(([to, label]) => (
                  <NavLink
                    key={to || "home"}
                    end
                    to={`/conference${to ? `/${to}` : ""}`}
                    data-testid={`conf-nav-${to || "dashboard"}`}
                    className={({ isActive }) =>
                      `rounded-sm px-2 py-1 text-xs font-semibold transition-colors ${
                        isActive ? "bg-[var(--mod-primary)] text-white" : "text-zinc-600 hover:bg-[var(--mod-hover)]"
                      }`
                    }
                  >
                    {label}
                  </NavLink>
                ))}
              </div>
            ))}
          </div>
        </div>
        <div className="mx-auto max-w-[1600px] px-4 py-6 sm:px-8">
          <Outlet />
        </div>
      </AppShell>
    </RoleProvider>
  );
}
